import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';

interface KpiProps {
  value: number;
  title: string;
  variant?: 'default' | 'warning';
  isLink?: boolean;
  to?: string;
  defaltStyle?: boolean;
}

export const Kpi: React.VFC<KpiProps> = ({
  value,
  title,
  variant = 'default',
  isLink = false,
  to = '',
  defaltStyle = true,
}) => {
  const history = useHistory();

  function handleNavigate() {
    if (isLink) {
      history.push(to);
    }
  }

  return defaltStyle ? (
    <Box
      transition="0.2s all linear"
      bg="#FAFAFA"
      border="1px solid #e5e5e6"
      borderRadius="8px"
      textAlign="center"
      padding="3"
      width="130px"
      maxHeight="130px"
      minHeight="105px"
      cursor={isLink ? 'pointer' : 'normal'}
      onClick={() => handleNavigate()}
      _hover={{
        background: isLink ? '#eeeeee' : '#FAFAFA',
        border: isLink ? '1px solid #cccccc' : '1px solid #e5e5e6',
      }}
    >
      <Text
        fontSize="2xl"
        fontWeight="bold"
        color={variant === 'default' ? 'black' : '#F66451'}
      >
        {value}
      </Text>
      <Text
        fontSize="sm"
        fontFamily="Roboto"
        color={variant === 'default' ? 'inherit' : '#F66451'}
      >
        {title}
      </Text>
    </Box>
  ) : (
    <Box
      transition="0.2s all linear"
      bg="#FAFAFA"
      borderLeft={
        variant === 'default' ? '4px solid #71C5E8' : '4px solid #F66451'
      }
      textAlign="center"
      padding="3"
      maxWidth="130px"
      maxHeight="48px"
      minHeight="48px"
      cursor={isLink ? 'pointer' : 'normal'}
      onClick={() => handleNavigate()}
      _hover={{
        background: isLink ? '#eeeeee' : '#FAFAFA',
        borderLeft: isLink ? '4px solid #cccccc' : '4px solid #71C5E8',
      }}
      display="flex"
      alignItems="center"
    >
      <Text fontSize="2xl" fontWeight="bold">
        {value}
      </Text>
      <Text
        fontSize="sm"
        fontFamily="Roboto"
        lineHeight={4}
        marginStart={3}
        textAlign="left"
      >
        {title}
      </Text>
    </Box>
  );
};
